import type { AnnotationEntry } from '@geosoft/viewer-sdk';

export interface ModelTreeNode {
  readonly id: string;
  readonly label: string;
  readonly kind: 'root' | 'layers' | 'layer' | 'annotations' | 'annotation';
  readonly children?: ReadonlyArray<ModelTreeNode>;
}

export function buildModelTree(
  visibleLayerIds: ReadonlyArray<string>,
  annotations: ReadonlyArray<AnnotationEntry>,
): ModelTreeNode {
  return {
    id: 'project',
    label: 'Dubai vertical slice',
    kind: 'root',
    children: [
      {
        id: 'layers',
        label: `Layers (${visibleLayerIds.length})`,
        kind: 'layers',
        children: visibleLayerIds.map((layerId) => ({
          id: `layer:${layerId}`,
          label: layerId,
          kind: 'layer',
        })),
      },
      {
        id: 'annotations',
        label: `Annotations (${annotations.length})`,
        kind: 'annotations',
        children: annotations.map((annotation) => ({
          id: `annotation:${annotation.id}`,
          label: String(annotation.properties.label ?? annotation.kind),
          kind: 'annotation',
        })),
      },
    ],
  };
}

export function flattenModelTree(node: ModelTreeNode): ModelTreeNode[] {
  return [node, ...(node.children?.flatMap(flattenModelTree) ?? [])];
}
